import axios from "axios";
import Vue from "vue";
import router from '@/router/index'

const REFRESH_TOKEN_URL = "/v1/Account/RefreshToken";
const LOGIN_URL = "/v1/Account/Login";

function isAuthRequest(url = "") {
  return url.includes(LOGIN_URL) || url.includes(REFRESH_TOKEN_URL);
}

function clearSessionAndRedirect() {
  localStorage.clear();
  if (router.currentRoute.path !== "/auth" && router.currentRoute.path !== "/register") {
    router.push({ path: "/auth" });
  }
}

axios.interceptors.request.use(
  (config) => {
    const partnerId = localStorage.getItem("partner_id");
    config.headers = config.headers || {};

    if (partnerId) {
      config.headers["partner-id"] = partnerId;
    }

    const token = localStorage.getItem("api_token");
    if (token && !isAuthRequest(config.url)) {
      const authorization = `Bearer ${token}`;
      config.headers["Authorization"] = authorization;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },

  function (error) {
    const originalConfig = error.config;
    if (!originalConfig || !error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalConfig._retry && !isAuthRequest(originalConfig.url)) {
      const accessToken = localStorage.getItem("api_token");
      const refreshToken = localStorage.getItem("api_refresh_token");

      if (!accessToken || !refreshToken || !Vue.prototype.$apiAdress) {
        clearSessionAndRedirect();
        return Promise.reject(error);
      }

      originalConfig._retry = true;

      return axios
        .post(
          `${Vue.prototype.$apiAdress}${REFRESH_TOKEN_URL}`,
          {
            accessToken,
            refreshToken,
          },
          {
            headers: {
              "partner-id": localStorage.getItem("partner_id") || undefined,
            },
          }
        )
        .then(function (response) {
          localStorage.setItem("api_token", response.data.accessToken);
          localStorage.setItem("api_refresh_token", response.data.refreshToken);

          originalConfig.headers = originalConfig.headers || {};
          originalConfig.headers["Authorization"] = `Bearer ${response.data.accessToken}`;

          return axios(originalConfig);
        })
        .catch(function (refreshError) {
          clearSessionAndRedirect();
          return Promise.reject(refreshError);
        });
    }

    if (error.response.status === 401) {
      clearSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);

export default axios;
